import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { updateFilters } from './../commonActions';
import { IDLE, LOADING, SUCCEEDED, ERROR } from '../../app/statusTypes';
import { fetchDashboard } from '../../api/safite';
import { createDefaultFilters, resolveFilters } from '../../utils/calcularFechas';

const initialState = {
    value: null,
    status: {
        value: IDLE,
        errorMessage: null,
    },
    filters: createDefaultFilters(),
};

export const getLayout = createAsyncThunk('layout/getLayout', async (_, { rejectWithValue }) => {
    try {
        const response = await fetchDashboard();
        return response;
    } catch (err) {
        return rejectWithValue(err);
    }
});

export const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getLayout.pending, (state) => {
                state.status.value = LOADING;
            })
            .addCase(getLayout.fulfilled, (state, action) => {
                const isFailed = action.payload?.data?.success ?? false;
                state.status.value = isFailed ? ERROR : SUCCEEDED;
                state.value = action.payload || [];
            })
            .addCase(getLayout.rejected, (state, action) => {
                state.status.value = ERROR;
                state.status.errorMessage = action?.payload?.message || 'Error desconocido';
            })
            .addCase(updateFilters, (state, action) => {
                state.filters = resolveFilters({ ...state.filters, ...action.payload });
            });
    },
});

// Actions
export { updateFilters };

// Selects
export const selectFilters = (state) => state.layout.filters;
export const selectStartDate = (state) => state.layout.filters.startDate;
export const selectEndDate = (state) => state.layout.filters.endDate;
export const selectLayout = (state) => state.layout.value;
export const selectStatus = (state) => state.layout.status;

export default layoutSlice.reducer;
